// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.roles_dashboard__4yfgl {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.roles_dashboardContain__gHdlb {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.roles_bodythemedark__\\+pgu- .roles_dashboardContain__gHdlb,
.roles_bodythemedark__\\+pgu- .roles_dashboard__4yfgl,
.roles_bodythemedark__\\+pgu- .roles_cont2__F1WGU {
  background-Color: #0f1824;
}

.roles_top_header__wY04w .roles_top_header_inner__R7\\+11 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.roles_cont2__F1WGU {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.roles_subLink__MlV\\+B svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.roles_footer__T\\+vWg {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.roles_bodythemelight__sS\\+-A {
  background-color: #fff;
  padding-top: 90px;
}

.roles_bodythemedark__\\+pgu- {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.roles_headerthemelight__hiV4V {
  background-color: #fff;
}

.roles_headerthemedark__Mj8Nq {
  background-color: #132337;
}

.roles_top_header__wY04w {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.roles_menuthemelight__zWxpo {
  background-color: #fff;
}

.roles_menuthemedark__\\+RiU\\+ {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.roles_menulinklight__PK4wh span {
  color: #666666 !important;
}

.roles_menulinklight__PK4wh a {
  color: #CBCBCB !important;
}

.roles_menulinklight__PK4wh:hover span, .roles_menulinklight__PK4wh:hover a {
  color: #fff !important;
}

.roles_menulinkdarkSelected__DWw4c {
  background-color: #1c2e45;
  color: #3b82f6;
}

.roles_menuthemelight__zWxpo .roles_menulinklightSelected__0oUik {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.roles_menulinkdark__UHzLp {
  color: #92afd3 !important;
}

.roles_menulinklight__PK4wh:hover {
  color: #fff !important;
  background-color: #131F43;
}

.roles_menulinklight__PK4wh .roles_sub_arrow__9CAnX svg path {
  stroke: #CBCBCB !important;
}

.roles_menulinklight__PK4wh:hover .roles_sub_arrow__9CAnX svg path {
  stroke: #fff !important;
}

.roles_menulinkdark__UHzLp .roles_sub_arrow__9CAnX svg path {
  stroke: #92afd3 !important;
}

.roles_menulinkdark__UHzLp:hover .roles_sub_arrow__9CAnX svg path {
  stroke: #fff !important;
}

.roles_menulinkdark__UHzLp:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.roles_headinglight__sFFb2 {
  color: #60677e;
}

.roles_headingdark__HqAwD {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.roles_searchboxlight__ITJcb {
  background-color: #fff;
  border: none;
}

.roles_searchboxdark__FXbvW {
  background-color: #132337;
  color: #fff;
  border: none;
}

.roles_searchboxdark__FXbvW::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.roles_tableheadlight__xTDAq {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.roles_tableheadlight__xTDAq th {
  color: #fff;
}

thead .roles_tableheadlight__xTDAq th:first-child,
thead .roles_tableheaddark__J0LSu th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .roles_tableheadlight__xTDAq th:last-child,
thead .roles_tableheaddark__J0LSu th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.roles_table__PWWVQ.roles_table-borderless__MuPJ5 {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.roles_tableheaddark__J0LSu {
  background-color: #132337;
  color: #fff;
}

.roles_table-borderless__MuPJ5 tr:nth-child(even) {
  background-color: #F9FAFB;
}

.roles_table-borderless__MuPJ5 .roles_left-section__Z0ABk {
  padding-top: 10px;
}

.roles_tablebodylight__0Ou95 td,
.roles_tablebodydark__Ngbad td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.roles_tablebodylight__0Ou95 {
  background-color: #fff;
}
.roles_tablebodylight__0Ou95:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.roles_tablebodydark__Ngbad {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.roles_tablebodydark__Ngbad:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.roles_paginationlight__yamMe {
  color: #60677e !important;
  font-size: 13px !important;
}

.roles_paginationdark__TjEXJ {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.roles_formthemelight__PmCyW {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.roles_formthemedark__Xh2Nd {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.roles_formthemedark__Xh2Nd ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.roles_viewformlight__IJDiM {
  background-color: #f3f6f9;
}

.roles_permissionboxlight__ftJGG {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.roles_permissionboxdark__DI9iz {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.roles_errormsgclr__V4ArJ {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.roles_graphclrlight__qRcLf {
  background-color: #fff;
}

.roles_graphclrdark__n\\+HC8 {
  background-color: #132337;
}

/* 
Counter theme
*/
#roles_card1bglight__y25Vd {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#roles_card1bgdark__AmVLQ {
  background: #392f28;
}

#roles_card2bglight__bb8Lp {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#roles_card2bgdark__R9941 {
  background: #1c3238;
}

#roles_card3bglight__Wiala {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#roles_card3bgdark__Nisqf {
  background: #3a2434;
}

#roles_card4bglight__IOSx6 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#roles_card4bgdark__HIH4M {
  background: #2f264f;
}

#roles_card1bgdark__AmVLQ a, #roles_card1bgdark__AmVLQ p,
#roles_card2bgdark__R9941 a, #roles_card2bgdark__R9941 p,
#roles_card3bgdark__Nisqf a, #roles_card3bgdark__Nisqf p,
#roles_card4bgdark__HIH4M a, #roles_card4bgdark__HIH4M p {
  color: #fff;
}

/* 
Action button theme
*/
.roles_actionbtnlight__023vz {
  color: rgba(70, 71, 91, 0.8705882353);
}

.roles_actionbtnlight__023vz:hover {
  cursor: pointer;
}

.roles_actionbtndark__4YaoZ {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.roles_profiledropdownlight__zL-Fd {
  background-color: #fff;
}

.roles_profiledropdowndark__vH2QF {
  background-color: #151521;
}

.roles_settingsection__65PaT #roles_addform__uWqXn.roles_formthemedark__Xh2Nd .roles_savebtn__bECTl {
  background-color: #3b82f6;
  color: #fff;
}

#roles_addform__uWqXn.roles_formthemedark__Xh2Nd .roles_savebtn__bECTl {
  background-color: #3b82f6;
  color: #fff;
}

.roles_profile_conatiner__Y4Pew {
  border-radius: 5px !important;
}

.roles_bodythemedark__\\+pgu- .roles_ag-theme-alpine__tTn8n .roles_ag-row__2k0hz {
  background: #000 !important;
}

.roles_bodythemedark__\\+pgu- .roles_formbtn__SIUw4 {
  background-color: #3b82f6;
}

.roles_bodythemedark__\\+pgu- .roles_formbtn__SIUw4:hover {
  background-color: #2563eb;
}

.roles_bodythemedark__\\+pgu- .roles_resetbtn__nWp-o {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.roles_bodythemedark__\\+pgu- .roles_resetbtn__nWp-o:hover {
  background-color: #3b82f6;
}

.roles_headingdark__HqAwD span {
  background-color: #132337;
}

.roles_resetbtn__nWp-o {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.roles_resetbtn__nWp-o:hover,
.roles_resetbtn__nWp-o:active,
.roles_resetbtn__nWp-o:focus {
  background-color: #131F43;
  color: #fff;
}

.roles_addBtn__cUza8 {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.roles_addbtnlight__TkwhW {
  background-color: #38A169;
}

.roles_addbtndark__5JAW8 {
  background-color: #3b82f6;
}

.roles_addbtndark__5JAW8:hover {
  background-color: #2563eb;
}

.roles_formthemedark__Xh2Nd label {
  color: #92afd3;
}

.roles_addBtn__cUza8 svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.roles_addBtn__cUza8:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.roles_cust_addBtn__RVj47.roles_addBtn__cUza8 svg {
  top: 2px;
}

.roles_deleteBtn__2sSSF {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.roles_deleteBtn__2sSSF {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.roles_deleteBtn__2sSSF:active, .roles_deleteBtn__2sSSF:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.roles_deleteBtn__2sSSF svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.roles_deleteBtn__2sSSF:hover,
.roles_deleteBtn__2sSSF:active,
.roles_deleteBtn__2sSSF:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.roles_confirmBtn__x90jn {
  background-color: #131F43;
}

.roles_confirmBtn__x90jn:hover,
.roles_confirmBtn__x90jn:active,
.roles_confirmBtn__x90jn:focus {
  background-color: #131F43;
}

.roles_confirmBtn__x90jn svg {
  top: 0;
}

.roles_delPopContainer__P5QYh .roles_modal-body__ZEecF {
  padding: 25px;
  text-align: center;
}

.roles_delPopContainer__P5QYh .roles_delet_icon__5Qqlk {
  margin-bottom: 11px;
}

.roles_delPopContainer__P5QYh p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.roles_arrowback__avrSX svg {
  fill: #000;
}

.roles_bodythemedark__\\+pgu- .roles_arrowback__avrSX {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.roles_bodythemedark__\\+pgu- .roles_arrowback__avrSX svg {
  fill: #3b82f6;
}

.roles_bodythemedark__\\+pgu- .roles_drpdwn_btn__JX10t {
  background-color: #132337;
}

.roles_bodythemedark__\\+pgu- .roles_empname__DlgcD {
  color: #92afd3 !important;
}

.roles_bodythemedark__\\+pgu- .roles_navitemli__0Xjuw a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.roles_bodythemedark__\\+pgu- .roles_tabnavli__UamO2 a.roles_settingsgeneral__JWaUi,
.roles_bodythemedark__\\+pgu- .roles_tabnavli__UamO2 a.roles_settingslinks__Nd0Ip:hover {
  background-color: #3b82f6;
  color: #fff;
}

.roles_bodythemedark__\\+pgu- .roles_tabnavli__UamO2 a.roles_settingslinks__Nd0Ip {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.roles_headerthemedark__Mj8Nq .roles_dropdown_menu_contain__dfja9 {
  background-color: #1c2e45;
  color: #fff;
}

.roles_headerthemedark__Mj8Nq .roles_dropdown_menu_contain__dfja9 ul li a,
.roles_headerthemedark__Mj8Nq .roles_dropdown_menu_contain__dfja9 .roles_dropdown_item__FMgXU,
.roles_headerthemedark__Mj8Nq .roles_dropdown_menu_contain__dfja9 .roles_dropdown_item__FMgXU h5 {
  color: #fff;
}

.roles_headerthemedark__Mj8Nq .roles_dropdown_menu_contain__dfja9 ul li a:hover,
.roles_headerthemedark__Mj8Nq .roles_dropdown_menu_contain__dfja9 .roles_dropdown_item__FMgXU:hover {
  background-color: #132337;
  color: #fff;
}

.roles_dropdown_item__FMgXU:active {
  background-color: #F5F6FA;
}

.roles_profile_arrrow_dwn__e8jCx {
  stroke: #132337;
}

.roles_headerthemedark__Mj8Nq .roles_profile_arrrow_dwn__e8jCx {
  stroke: #fff;
}

.roles_dateinputbox1__YZVkX input,
.roles_dateinputbox1__YZVkX span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .roles_tableheadlight__xTDAq th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .roles_dashboard__4yfgl {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .roles_cont2__F1WGU {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .roles_sectionright__Y5Knj {
    float: unset !important;
  }
  .roles_dashboard__4yfgl {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .roles_cont2__F1WGU {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .roles_bodythemelight__sS\\+-A, .roles_bodythemedark__\\+pgu- {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .roles_exer_modal_contain__AF0z0 .roles_modal-dialog__Dhl6V {
    max-width: 1055px;
  }
  .roles_delPopContainer__P5QYh .roles_modal-dialog__Dhl6V {
    max-width: 350px;
  }
}
.roles_indexdiv__U57Ph #roles_addheading__zhrfZ {
  font-size: 18px;
  margin-bottom: 20px;
}
.roles_indexdiv__U57Ph .roles_exportsection__FKCTm {
  float: right;
  width: 100%;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  #roles_dashboardcont2__pgQDy {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/roles/index.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAmDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,2BAAA;EACA,gBAAA;ACzEF;;AD2EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACxEF;;AD0EA;;;EAGE,yBAlEoB;ACLtB;;ADyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACtEF;;ADyEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAzHO;EA0HP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACpEF;;AD0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACvEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBAjGY;ACwBd;;AD4EA;;CAAA;AAGA;EACE,sBAxGY;EAyGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAvHgB;EAwHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBApHY;AC4Cd;;AD2EA;EACE,yBAnIgB;AC2DlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAxIY;ACiEd;;ADyEA;EACE,yBAtJgB;ACgFlB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAvKsB;EAwKtB,cAlLkB;AC4GpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAlNc;AC6IhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBA3Nc;ACsJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBA1MsB;EA2MtB,WAlMY;AC6Hd;;ADwEA;;CAAA;AAGA;EACE,cAtMe;ACiIjB;;ADwEA;EACE,cA1Me;ACqIjB;;ADwEA;;CAAA;AAGA;EACE,sBApNY;EAqNZ,YAAA;ACrEF;;ADwEA;EACE,yBApOgB;EAqOhB,WA1NY;EA2NZ,YAAA;ACrEF;;ADuEA;EACE,cA3Ne;ACuJjB;;ADuEA;;CAAA;AAGA;EACE,yBAnRc;EAoRd,8BAAA;ACpEF;;ADsEA;EACE,WAzOY;ACsKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAvPkB;EAwPlB,WAhQY;ACkMd;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBA9QY;ACoNd;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cApRe;AC0NjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA/SY;EAgTZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBA5SkB;EA6SlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAtTa;AC6PjB;;AD8DA;;CAAA;AAGA;EACE,yBArUgB;AC0QlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBApVoB;EAqVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAxVY;AC8Rd;;AD6DA;EACE,yBApVkB;AC0RpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBArWY;AC0Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA9WY;ACmTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAvXY;AC4Td;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAhYY;ACqUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WA3YY;ACgVd;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cArZe;AC4VjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBAzbkB;EA0blB,WAzaY;AC+Wd;;AD4DA;EACE,yBA7bkB;EA8blB,WA7aY;ACoXd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBA1ckB;ACiZpB;;AD4DA;EACE,yBA7cwB;ACoZ1B;;AD4DA;EACE,WAjcY;EAkcZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAxdkB;AC+ZpB;;AD6DA;EACE,yBAvdgB;AC6ZlB;;AD6DA;EACE,eAAA;EACA,gBArgBc;EAsgBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAngBc;EAogBd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAzgBc;EA0gBd,WA5dY;ACmad;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WAleY;EAmeZ,yBA9fY;EA+fZ,YAAA;EACA,eAAA;EACA,gBA1hBc;ACiehB;;AD4DA;EACE,yBArgBY;AC4cd;;AD2DA;EACE,yBA9fkB;ACscpB;;AD0DA;EACE,yBAhgBwB;ACyc1B;;AD0DA;EACE,cAtgBiB;AC+cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA/fY;EAggBZ,yBA3hBY;EA4hBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA/hBW;EAgiBX,WA5gBY;EA6gBZ,eAAA;EACA,gBAlkBc;EAmkBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBAziBW;EA0iBX,WAthBY;EAuhBZ,eAAA;EACA,gBA5kBc;EA6kBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA/jBW;EAgkBX,WA5iBY;EA6iBZ,YAAA;ACxDF;;AD2DA;EACE,yBA/lBc;ACuiBhB;;AD2DA;;;EAGE,yBArmBc;AC6iBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCAnmBc;EAomBd,cAxmBkB;AC8iBpB;;AD6DA;EACE,aA5mBkB;ACkjBpB;;AD6DA;EACE,yBAxmBgB;AC8iBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAvmBY;AC6iBd;;AD6DA;;EAEE,yBA7nBkB;EA8nBlB,WA7mBY;ACmjBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlnBY;ACyjBd;;AD4DA;EACE,yBA/nBsB;EAgoBtB,WAvnBY;AC8jBd;;AD4DA;;;EAGE,WA7nBY;ACokBd;;AD4DA;;EAEE,yBA7oBgB;EA8oBhB,WAnoBY;AC0kBd;;AD4DA;EACE,yBAtrBO;AC6nBT;;AD4DA;EACE,eAtpBgB;AC6lBlB;;AD4DA;EACE,YA/oBY;ACslBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AAxsBI;EACI,eAAA;EACA,mBAAA;AA0sBR;AAxsBI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;AA0sBR;;AAnsBA;EACI;IACI,wBDyEI;ICxEJ,UDyEG;ICxEH,kBAAA;IACA,aDiEW;ECqoBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #DBEAFE;  \n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #D1FAE5;  \n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FEF3C7;  \n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #E9D5FF; \n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon1-color: #3B82F6;  \n$cardIcon2-color: #10B981;  \n$cardIcon3-color: #F59E0B;  \n$cardIcon4-color: #8B5CF6;  \n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n.indexdiv{\n\n    #addheading{\n        font-size: 18px;\n        margin-bottom: 20px;\n    }\n    .exportsection{\n        float: right;\n        width: 100%;\n        margin-bottom: 20px;\n    }\n}\n\n\n\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `roles_dashboard__4yfgl`,
	"dashboardContain": `roles_dashboardContain__gHdlb`,
	"bodythemedark": `roles_bodythemedark__+pgu-`,
	"cont2": `roles_cont2__F1WGU`,
	"top_header": `roles_top_header__wY04w`,
	"top_header_inner": `roles_top_header_inner__R7+11`,
	"subLink": `roles_subLink__MlV+B`,
	"footer": `roles_footer__T+vWg`,
	"bodythemelight": `roles_bodythemelight__sS+-A`,
	"headerthemelight": `roles_headerthemelight__hiV4V`,
	"headerthemedark": `roles_headerthemedark__Mj8Nq`,
	"menuthemelight": `roles_menuthemelight__zWxpo`,
	"menuthemedark": `roles_menuthemedark__+RiU+`,
	"menulinklight": `roles_menulinklight__PK4wh`,
	"menulinkdarkSelected": `roles_menulinkdarkSelected__DWw4c`,
	"menulinklightSelected": `roles_menulinklightSelected__0oUik`,
	"menulinkdark": `roles_menulinkdark__UHzLp`,
	"sub_arrow": `roles_sub_arrow__9CAnX`,
	"headinglight": `roles_headinglight__sFFb2`,
	"headingdark": `roles_headingdark__HqAwD`,
	"searchboxlight": `roles_searchboxlight__ITJcb`,
	"searchboxdark": `roles_searchboxdark__FXbvW`,
	"tableheadlight": `roles_tableheadlight__xTDAq`,
	"tableheaddark": `roles_tableheaddark__J0LSu`,
	"table": `roles_table__PWWVQ`,
	"table-borderless": `roles_table-borderless__MuPJ5`,
	"left-section": `roles_left-section__Z0ABk`,
	"tablebodylight": `roles_tablebodylight__0Ou95`,
	"tablebodydark": `roles_tablebodydark__Ngbad`,
	"paginationlight": `roles_paginationlight__yamMe`,
	"paginationdark": `roles_paginationdark__TjEXJ`,
	"formthemelight": `roles_formthemelight__PmCyW`,
	"formthemedark": `roles_formthemedark__Xh2Nd`,
	"viewformlight": `roles_viewformlight__IJDiM`,
	"permissionboxlight": `roles_permissionboxlight__ftJGG`,
	"permissionboxdark": `roles_permissionboxdark__DI9iz`,
	"errormsgclr": `roles_errormsgclr__V4ArJ`,
	"graphclrlight": `roles_graphclrlight__qRcLf`,
	"graphclrdark": `roles_graphclrdark__n+HC8`,
	"card1bglight": `roles_card1bglight__y25Vd`,
	"card1bgdark": `roles_card1bgdark__AmVLQ`,
	"card2bglight": `roles_card2bglight__bb8Lp`,
	"card2bgdark": `roles_card2bgdark__R9941`,
	"card3bglight": `roles_card3bglight__Wiala`,
	"card3bgdark": `roles_card3bgdark__Nisqf`,
	"card4bglight": `roles_card4bglight__IOSx6`,
	"card4bgdark": `roles_card4bgdark__HIH4M`,
	"actionbtnlight": `roles_actionbtnlight__023vz`,
	"actionbtndark": `roles_actionbtndark__4YaoZ`,
	"profiledropdownlight": `roles_profiledropdownlight__zL-Fd`,
	"profiledropdowndark": `roles_profiledropdowndark__vH2QF`,
	"settingsection": `roles_settingsection__65PaT`,
	"addform": `roles_addform__uWqXn`,
	"savebtn": `roles_savebtn__bECTl`,
	"profile_conatiner": `roles_profile_conatiner__Y4Pew`,
	"ag-theme-alpine": `roles_ag-theme-alpine__tTn8n`,
	"ag-row": `roles_ag-row__2k0hz`,
	"formbtn": `roles_formbtn__SIUw4`,
	"resetbtn": `roles_resetbtn__nWp-o`,
	"addBtn": `roles_addBtn__cUza8`,
	"addbtnlight": `roles_addbtnlight__TkwhW`,
	"addbtndark": `roles_addbtndark__5JAW8`,
	"cust_addBtn": `roles_cust_addBtn__RVj47`,
	"deleteBtn": `roles_deleteBtn__2sSSF`,
	"confirmBtn": `roles_confirmBtn__x90jn`,
	"delPopContainer": `roles_delPopContainer__P5QYh`,
	"modal-body": `roles_modal-body__ZEecF`,
	"delet_icon": `roles_delet_icon__5Qqlk`,
	"arrowback": `roles_arrowback__avrSX`,
	"drpdwn_btn": `roles_drpdwn_btn__JX10t`,
	"empname": `roles_empname__DlgcD`,
	"navitemli": `roles_navitemli__0Xjuw`,
	"tabnavli": `roles_tabnavli__UamO2`,
	"settingsgeneral": `roles_settingsgeneral__JWaUi`,
	"settingslinks": `roles_settingslinks__Nd0Ip`,
	"dropdown_menu_contain": `roles_dropdown_menu_contain__dfja9`,
	"dropdown_item": `roles_dropdown_item__FMgXU`,
	"profile_arrrow_dwn": `roles_profile_arrrow_dwn__e8jCx`,
	"dateinputbox1": `roles_dateinputbox1__YZVkX`,
	"sectionright": `roles_sectionright__Y5Knj`,
	"exer_modal_contain": `roles_exer_modal_contain__AF0z0`,
	"modal-dialog": `roles_modal-dialog__Dhl6V`,
	"indexdiv": `roles_indexdiv__U57Ph`,
	"addheading": `roles_addheading__zhrfZ`,
	"exportsection": `roles_exportsection__FKCTm`,
	"dashboardcont2": `roles_dashboardcont2__pgQDy`
};
export default ___CSS_LOADER_EXPORT___;
